import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { isAdminSelector, isManagerSelector } from '../selectors';
import { rebootSystem } from '../actions/entry';
import { clearMessage } from '../actions';
import RebootSystem from '../components/RebootSystem';

const mapStateToProps = (state) => {
  const isAdmin = isAdminSelector(state);
  const isManager = isManagerSelector(state);
  const { rebootSystemError } = state.system;

  return {
    canView: isAdmin || isManager,
    rebootSystemError,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onRebootSystem: rebootSystem,
      onClearMessage: clearMessage,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(RebootSystem);
